<template>
    <v-container class="px-6" style="align-self: center;">
        <v-dialog v-model="showFailedAttempts" persistent max-width="480">
            <v-card>
                <v-card-title class="headline">{{ failedAttemptsHeadline }}</v-card-title>
                <v-card-text v-html="failedAttemptsText">
                </v-card-text>
                <v-card-actions>
                    <v-btn dark raised
                           color="primary"
                           @click="failedAttempts < 3 ? $store.state.showOnlineFailedAttempts = false : backToLobby()" 
                           class="elevation-3">
                            {{ failedAttemptsButtonText }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-form v-model="$store.state.isOnlineValid" ref="onlineForm">
            <v-row v-if="!$store.state.onlineMultipleBookings">
                <v-col class="text-center">
                    <strong style="font-size: 16px;">Please enter your phone number OR confirmation number to sign in.</strong>
                </v-col>
            </v-row>
            <v-row v-if="!$store.state.onlineMultipleBookings">
                <v-col>
                    <v-btn-toggle v-model="$store.state.onlineOptionSelected" class="has-2-toggles" @change="optionChanged" mandatory>
                        <v-btn value="Phone" large outlined color="primary" light>Phone #</v-btn>
                        <v-btn value="ConfirmationNumber" large outlined color="primary" light>Confirmation #</v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
            <v-row v-if="!$store.state.onlineMultipleBookings">
                <v-col>
                    <v-text-field v-model="onlineInput"
                                  v-facade="mask"
                                  :placeholder="placeholder"
                                  :type="optionSelected === 'Phone' ? 'tel' : 'text'"
                                  :rules="rules"
                                  :pattern="pattern"
                                  ref="onlineInput"
                                  id="onlineInput"
                                  autocomplete="off"
                                  background-color="white"
                                  style="width: 50%; min-width: 180px;"
                                  @input="inputChanged"
                                  outlined
                                  solo
                                  clearable
                                  validate-on-blur>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row v-if="$store.state.onlineMultipleBookings">
                <v-col>
                    <strong style="font-size: 16px; color: #C90000;">
                        We found multiple bookings with this phone number. Please enter your DOB to confirm your booking. Alternatively, tap the back button and try your confirmation number instead.
                    </strong>
                </v-col>
            </v-row>
            <v-row v-if="$store.state.onlineMultipleBookings">
                <v-col>
                    <label style="font-size:16px;">Date of birth</label>
                    <v-text-field v-facade="'##/##/####'"
                                  v-model="$store.state.onlineDob"
                                  name="Dob"
                                  id="dob"
                                  class="mt-1"
                                  style="width: 50%"
                                  ref="dob"
                                  placeholder="MM/DD/YYYY"
                                  inputmode="numeric"
                                  type="tel"
                                  pattern="[0-9]*"
                                  background-color="white"
                                  autocomplete="off"
                                  :rules="dobRules"
                                  solo
                                  outlined>
                    </v-text-field>
                </v-col>
            </v-row>
        </v-form>
    </v-container>
</template>

<script>
    /*eslint-disable no-useless-escape*/

    // This piece gave me more troubles than expected,
    // model binding is not working properly (even with 2 diff text fields with diff v-model)
    import ContextualMixin from '../mixins/contextualMixin'
    import moment from 'moment'

    export default {
        name: 'Online',
        mixins: [ContextualMixin],
        data() {
            return {
                onlineInput: null,
                phoneRules: [
                    v => !!v || 'Phone is required.',
                    v => /^(?:(1\-?)|(\+1 ?))?\(?\d{3}\)?[\-\.\s]?\d{3}[\-\.\s]?\d{4}$/.test(v) || 'Phone is invalid',
                    v => /^(\d)(?!\1+$)\d{9}$/.test(this.unmask(v, '(###)-###-####')) || 'Phone is invalid'
                ],
                confirmationNumberRules: [
                    v => !!v || 'Confirmation number is required',
                    v => !!v && v.length === 15 || 'Confirmation number is invalid'
                ],
                dobRules: [
                    v => !!v || 'Date of birth is required',
                    v => moment(v, 'MM/DD/YYYY', true).isValid() || 'Date of birth is invalid',
                    v => moment().diff(v, 'years', false) < 200 || 'Date of birth is invalid'
                ]
            }
        },
        computed: {
            optionSelected() { return this.$store.state.onlineOptionSelected; },
            rules() { return this.optionSelected === 'Phone' ? this.phoneRules : this.confirmationNumberRules; },
            mask() { return this.optionSelected === 'Phone' ? '(###)-###-####' : 'XXXXX-XXXXX-XXX'; },
            placeholder() { return this.optionSelected === 'Phone' ? '(___)-___-____' : '_____-_____-____'; },
            failedAttempts() { return this.$store.state.onlineFailedAttempts; },
            multipleBookings() { return this.$store.state.onlineMultipleBookings; },
            inputState() { return this.$store.state.onlineInput; },
            pattern() { return this.optionSelected === 'Phone' ? '[0-9]*' : '' },
            failedAttemptsHeadline() {
                if (this.failedAttempts < 3)
                    return 'Sorry, we cannot find your reservation';
                else
                    return 'Hmmm, we still cannot find your reservation';
            },
            failedAttemptsText() {
                if (this.failedAttempts < 3)
                    return 'Please double check your information and try again.';
               else
                    return `Please call <a href="tel:${this.unmask(this.currentModel.settings.clientPhone, '(###) ###-####')}">${this.currentModel.settings.clientPhone}</a> and one of our staff will assist you. It's important for us to know you're here.`;
            },
            failedAttemptsButtonText() {
                return this.failedAttempts < 3 ? 'Try again' : 'Go back home';
            }
        },
        mounted() {
            this.$store.state.isOnline = true;
            this.$store.state.currentStep = 1;            
            this.onlineInput = null;
        },
        methods: {
            inputChanged() {
                if (this.optionSelected === 'Phone')
                    this.$store.state.onlineInput = this.onlineInput;
                else
                    this.$store.state.onlineInput = this.unmask(this.onlineInput, 'XXXXX-XXXXX-XXX');
            },
            optionChanged() {
                this.$refs.onlineForm.reset();
                this.$refs.onlineForm.resetValidation();
                this.$store.state.onlineInput = null;
                this.onlineInput = null;               
                setTimeout(() => { this.onlineInput = null; this.$store.state.onlineInput = null }, 20);
            }
        },
        watch: {
            multipleBookings: function (n, o) {
                if (!n && o)
                    setTimeout(() => { this.onlineInput = null; this.$store.state.onlineInput = null }, 20);
            }
        }
    }
</script>

<style>
    #onlineInput {
        letter-spacing: 1px;
    }
</style>
